<template>
  <div
    class="absolute inset-0 w-full h-full pointer-events-none z-5"
    :style="bgStyle"
  />
</template>

<script setup lang="ts">
const colorMode = useColorMode();
const isLight = computed(() => colorMode.value !== 'dark');

const opacity = computed(() => (isLight.value ? 0.03 : 0.12));

const bgStyle = computed(() => ({
  backgroundImage: `repeating-linear-gradient(
    0deg,
    rgba(105, 111, 208, ${opacity.value}) 0px,
    rgba(105, 111, 208, ${opacity.value}) 2px,
    transparent 2px,
    transparent 6px
  )`,
}));
</script>
